import React, { useState } from 'react';
import './HorizontalOptionButtons.css';
import { Globals as OldGlobals } from '../../global/Globals';
import { useLanguage } from '../../context/Languagecontext';

const HorizontalOptionButtons = ({ onChange, selectedOption,isVirtualPitch }) => {
    const {Globals} =useLanguage();

    const handleOptionChange = (event) => {
        onChange(event.target.value);

    };

    return (
        <div>
            <div className="radio-button-group">
                 {!isVirtualPitch && (
                    <>
                        <input
                            className="sm-brief-radio-button-text"
                            type="radio"
                            value={Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH}
                            checked={selectedOption === Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH}
                            onChange={handleOptionChange}
                        /> <label>
                            {Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_VIRTUALPITCH}
                        </label>
                    </>
                )
                }

                <input
                    className="sm-brief-radio-button-text"
                    type="radio"
                    value={Globals.SENIOR_MANAGER.OPTIONS.RE_WORK}
                    checked={selectedOption === Globals.SENIOR_MANAGER.OPTIONS.RE_WORK}
                    onChange={handleOptionChange}
                /> <label>
                    {Globals.SENIOR_MANAGER.OPTIONS.RE_WORK}
                </label>

                <input
                    className="sm-brief-radio-button-text"
                    type="radio"
                    value={Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_INMANAGEMENT_PITCH}
                    checked={selectedOption === Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_INMANAGEMENT_PITCH}
                    onChange={handleOptionChange}
                />
                <label>
                    {Globals.SENIOR_MANAGER.OPTIONS.INVITE_TO_INMANAGEMENT_PITCH}
                </label>
                <input
                    className="sm-brief-radio-button-text"
                    type="radio"
                    value={Globals.SENIOR_MANAGER.OPTIONS.UNSUCCESSFUL}
                    checked={selectedOption === Globals.SENIOR_MANAGER.OPTIONS.UNSUCCESSFUL}
                    onChange={handleOptionChange}
                />
                <label>
                    {Globals.SENIOR_MANAGER.OPTIONS.UNSUCCESSFUL}
                </label>
            </div>

        </div>
    );
};

export default HorizontalOptionButtons;
